import styled from "styled-components";
import { COLORS } from "../../../../../../styles/constants.style";

export const CancelContractDocumentModalsWrapper = styled.div`
  .container {
    padding: 24px 16px 24px 16px;
    overflow: auto;
    max-height: 290px;
  }

  .separator {
    width: 100%;
    border-bottom: 1px solid ${COLORS.primary_light_blue4};
    &.dashed {
      border-bottom-style: dashed;
    }
  }
  .cancel-contract-document-comment {
    margin-top: 16px;
    display: grid;

    .comment-input {
      .MuiInputBase-root {
        height: 100px;
        background: ${COLORS.cirrus_black1};
        padding: 0px;
      }
    }
  }
`;
